import React from 'react';
import '../css/App.css';
import ProfileCard from './ProfileCard';
import { Typography, Divider } from '@material-ui/core';
import brittanyAvatar from '../img/headshots/brittanyFinlay.jpg';
import jenniferAvatar from '../img/headshots/jenniferZwicker.jpg';

//This Component created to reduce import clutter in App.js
export default function ContactCollection() {
  return (
    <div>
      <Typography variant='h3' align="center">Behind the Data</Typography>
      <Divider key={"contactDivider"} light={true}/>
      <div className ="contactCollection">
        <ProfileCard 
          img={brittanyAvatar} 
          contactName="Brittany Finlay" 
          contactDesc="Research Associate, School of Public Policy, University of Calgary" 
          contactInfo="brittany.finlay1@ucalgary.ca" 
        />
        <ProfileCard 
          img={jenniferAvatar} 
          contactName="Jennifer Zwicker" 
          contactDesc= {["Director of Health Policy, School of Public Policy, University of Calgary",<br/>,<br/>,"Assistant Professor, Faculty of Kinesiology, University of Calgary"]}
          contactInfo="zwicker1@ucalgary.ca" 
        />
      </div>
    </div>
  );
}